import Form from '../components/form_controller';

export default class OptionFilterController extends Form {
  
  dropdownIds = ['option_set'];
  
  static targets = ['form',]
}
